import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Observable } from 'rxjs';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class ExpressService {
  public isOpen: boolean = false;
  public isLoading: boolean = false;

  public expressListHeader:any = [];
  public expressListData:any = [];
  public listPage:number = 1;
  public listTotalPage:number = 1;

  public savePayloadObject:any = {};
  public savePrevPayloadObject:any ="";
  public expressSaveId:any = "";
  public expressUUid:string = "";
  public isShowDownload:boolean = true;
  public isFormReload:boolean=false;
  public backTrack:string="";

  public eid:string = "";
  public dataSaving:boolean = false;
  public showDataSaving:boolean = false;

  public updateRelatedFieldEmitter = new EventEmitter<any>();
  // public onContractDetailsReload = new EventEmitter();
  public isExpressFormReloadEmitter = new EventEmitter<any>();
  public headerSearchEventEmitter = new EventEmitter<any>();
  public isSearchShow: boolean = false;


  constructor(
    private apiRequest: ApiRequestService,
    public notifier:NotifierService,
    private router: Router
  ) { }

  getListData(query?){
    this.getListApiCall(query).subscribe((res:any) =>{
      if(res && res.status){
        this.setHeaders(res.headers);
        this.listPage = Number(res.page);
        this.listTotalPage = res.total_page;
        if (this.listPage == 1) {
          this.expressListData = res.data;
        }else{
          this.expressListData = [...this.expressListData,...res.data];
        }
        
      }else{
        this.notifier.notify('error',res.message);

      }
      
    });
  }

  getListApiCall(query?):Observable<any> {
    let opt = {};
    if(query)opt['query'] = query;
    return this.apiRequest.request('GET','/v2/express/list',{},opt);
  }

  setHeaders(header){
    this.expressListHeader = [];
    Object.keys(header).forEach((key) => {
      this.expressListHeader.push({'label':header[key]['label'],'key':key});
    });
    // console.log(this.expressListHeader);
  }

  getExpressDetails(uuid,version?:string): Observable<any> {
    let opt = {};
    if(version && version!='')opt['query'] = {"version":version};
    return this.apiRequest.request('GET','/v2/express/expressDataDetails/'+uuid,{},opt);
  }

  getForm(query): Observable<any> {
    let opt = {};
    if(query)opt['query'] = query;
    return this.apiRequest.request('GET','/v2/express/list/form',{},opt);
  }
  getQuoteData(uuid): Observable<any> {
    return this.apiRequest.request('GET','/v2/express/expressData/'+uuid);
  }

  backToTrack(){
    if(this.backTrack && this.backTrack != ""){
      if(this.backTrack == "express-list"){
        this.router.navigate(['/express']);
      }else if(this.backTrack == "express-details"){
        this.router.navigate(['/express/details/'+this.expressSaveId]);
      }else if(this.backTrack == "express-request"){ 
        this.router.navigate(['/express/request/'+this.expressSaveId]);
      }else{
        this.router.navigate(['/express']);
      }
      this.backTrack = "";
    }else{
      this.router.navigate(['/express']);
    }

  }

  // saveContractQuotePayload(){
  //   this.dataSaving = true
  //   this.showDataSaving = true
  //   this.saveQuotePayloadApiCall().subscribe((res:any) => {
  //     if(res && res.status  && res.status == 1){
  //       this.expressSaveId = res.id || "";
  //       this.dataSaving = false;
  //       this.eid = res.eid;
  //       if (!(this.expressUUid && this.expressUUid !="")) {
  //         this.expressUUid = res.id;
  //         this.router.navigate(['/express/request/'+res.id]);
  //       }
  //       if(this.isFormReload){
  //         this.isFormReload = false;
  //         this.isReloadFormEmitter.emit();
  //       }
  //       this.resetQuotePayload();
  //     }else if(res && res.status  && res.status == 2){
  //       this.expressSaveId = res.id || "";
  //       this.dataSaving = false;
  //       this.updateRelatedFieldEmitter.emit(res.data);
  //       if(this.isFormReload){
  //         this.isFormReload = false;
  //         this.isReloadFormEmitter.emit();
  //       }
  //       this.resetQuotePayload();
  //     }else{
  //       this.notifier.notify('error',res.message);
  //       this.dataSaving = false;
  //       this.showDataSaving = false
  //     }
  //   })
  // }

   saveExpressQuotePayload(){
    this.dataSaving = true
    this.showDataSaving = true
    this.saveQuotePayloadApiCall().subscribe((res:any) => {
      if(res && res.status  && res.status == 1){
        this.expressSaveId = res.id || "";
        this.dataSaving = false;
        this.eid = res.eid;
        if (!(this.expressUUid && this.expressUUid !="")) {
          this.expressUUid = res.id;
          this.router.navigate(['/express/request/'+res.id]);
        }
        if(this.isFormReload){
          this.isFormReload = false;
          // console.log("isExpressFormReloadEmitter for status 1");
          this.isExpressFormReloadEmitter.emit({"uuid":res.id});
        }
        this.resetQuotePayload();
      }else if(res && res.status  && res.status == 2){
        this.expressSaveId = res.id || "";
        this.dataSaving = false;
        this.updateRelatedFieldEmitter.emit(res.data);
        if(this.isFormReload){
          this.isFormReload = false;
          // console.log("isExpressFormReloadEmitter for status 2");
          this.isExpressFormReloadEmitter.emit({"uuid":res.id});
        }
        this.resetQuotePayload();
      }else{
        this.notifier.notify('error',res.message);
        this.dataSaving = false;
        this.showDataSaving = false
      }
    })
  }

  sendExpress(uuid){
    this.sendExpressApiCall(uuid).subscribe((res:any) => {
      if(res && res.status  && res.status == 1){
        this.notifier.notify('success',"Request sent successfully");
        // this.notifier.notify('success',res.message);
        this.router.navigate(['/express/details/'+uuid]);
      }else{
        this.notifier.notify('error',res.message);
      }
    })
  }

  sendExpressApiCall(uuid): Observable<any> {
    return this.apiRequest.request('POST','/v2/express/expressSend/'+uuid,{});
  }

  saveQuotePayloadApiCall(): Observable<any> {
    let body = {data:this.savePayloadObject};
    if(this.expressSaveId){
      body['id'] = this.expressSaveId;
    }
    return this.apiRequest.request('POST','/v2/express/saveExpress',body);
  }

   resetQuotePayload(){
    this.savePayloadObject = {};
    this.savePrevPayloadObject = "";
  }




}
